import { Service } from "../../Model";
import { AdminBarberRepository } from "../../Repository";

export async function deleteService(
  serviceName: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.deleteService(serviceName);
}
